enum SeasonType {
	DefaultSeason = 'Default Season',
	HighSeason = 'High Season',
	LowSeason = 'Low Season'
}

export default SeasonType;
